export default __webpack_public_path__ + "static/media/example-stanford-IMG.aa7a0ddf.jpg";